<sm-options-content-layout optionsWidthClass="width300" mobileMode="overlay" contentStyleClass="flex-col width100p">
    <ng-template #options>
        <p-panel class="height100p full-height flex-col" [header]="app.t('ProjectPlanning.options')">
            <p-tree class="flex-item-fill height400p full-height mb-1" [value]="tree" selectionMode="checkbox" [filter]=true filterBy="label,data.projectNumber" [(selection)]="selectedProjects" (contextmenu)="projectContextMenu($event)" (selectionChange)="projectsChanged()">
            </p-tree>
            <sm-form class="flex-item-fixed mt-3" [form]="form"></sm-form>
        </p-panel>
    </ng-template>

    <ng-template #content>
        <div class="width100p height100p flex-col">
            <app-project-toolbar [calendarWrapper]="calendarWrapper" [forProjects]=true>
            </app-project-toolbar>
            <full-calendar #fc class="width100p flex-item-fill pp-fullcal" [options]="calendarWrapper.options"></full-calendar>
        </div>
    </ng-template>
</sm-options-content-layout>
